import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/topsolid.webp';
import screenshot_target from '../../../images/letterfunnel/albertkuiper.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Albert Kuiper"
      firstname="Albert"
      companyname="TopSolid"
      competition="OpenMind en Cadmes"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/albertkuiper.js